import React, { useState } from 'react';
import { BookOpen, ExternalLink, Search } from 'lucide-react';

const SwimGlossary: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const terms = [
    { term: 'Build', definition: 'Get faster through the swim. For example, "100 build" means your effort and pace should increase throughout the 100m.' },
    { term: 'C/D', definition: 'The cool-down section of the session. Effort and pace should gradually decrease to "very easy."' },
    { term: 'Descend', definition: 'Descend the speed of each rep (get faster each time). For example, "8 x 100m Desc" means swim each rep slightly faster than the one before.' },
    { term: 'Desc 2-2-2-2', definition: 'Descend the speed of each pair of reps. So "8 x 100 Desc 2-2-2-2" means swim first 2 at a speed, next 2 slightly faster, etc.' },
    { term: 'Even / Odd', definition: 'Perform one kind of drill on the ODD reps (1,3,5) and another on the EVEN reps (2,4,6).' },
    { term: 'Free / FS', definition: 'Freestyle' },
    { term: 'Fast', definition: 'As fast as you can swim for that particular rep.' },
    { term: 'Negative Split', definition: 'The second half of the rep is faster than the first part.' },
    { term: 'Pull', definition: 'Swim with a pull buoy between your legs. This isolates the arms for a more muscular endurance workout.' },
    { term: 'RI', definition: 'Rest interval. "on 20s" means you get 20 seconds rest before the next rep.' },
  ];

  const filteredTerms = terms.filter(term =>
    term.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
    term.definition.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Swim Terminology Glossary</h1>
        <p className="text-muted">Common shorthand used in swim training plans.</p>
      </div>

      <div className="mb-6">
        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#718096]" size={18} />
          <input
            type="text"
            placeholder="Search terms..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10"
          />
        </div>
      </div>

      <div className="grid gap-4 mb-8">
        {filteredTerms.map((item) => (
          <div key={item.term} className="card-base p-6">
            <h2 className="text-xl font-semibold text-[#3b82f6] mb-2">{item.term}</h2>
            <p className="text-[#e2e8f0]">{item.definition}</p>
          </div>
        ))}
      </div>

      <div className="card-base p-6">
        <div className="flex items-start space-x-4">
          <div className="p-3 bg-[rgba(59,130,246,0.1)] rounded-lg">
            <BookOpen className="text-[#3b82f6]" size={24} />
          </div>
          <div>
            <h3 className="font-semibold mb-2">Swim Drills Reference</h3>
            <p className="text-muted mb-3">
              For video demonstrations of swim drills, visit the comprehensive drill guide.
            </p>
            <a
              href="https://www.oxygenaddict.com/swim-drills"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-[#3b82f6] hover:text-[#60a5fa] no-underline"
            >
              <span>View Swim Drills Videos</span>
              <ExternalLink size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwimGlossary;
